export const LandingPageType = {
  reactivate: 'reactivate',
  addMembership: 'addMembership'
}
